import API from "../config/api.js";


export const CompanyBankService = {

    create(data) {
        return API.post(`api/companyBankAcc/create`,data);
    },
    getBankAccountList(search, page = 1) {
    
        return API.get(`/api/companyBankAcc/list/se=${search}`, { params: { page: page } });
    },
    BankAccountUpdate(id,data) {
        return API.put(`api/companyBankAcc/info/update/${id}`,data);
    },
    getBankAccountDetails(uuid) {
        return API.get(`api/companyBankAcc/info/${uuid}`);
    },

    getCountries(){
        console.log("countries called")
        return API.get(`api/companyBankAcc/countries`);
    },
    getBranches(){
        console.log("branches called")
        return API.get(`api/companyBankAcc/branches`);
    },
    getBanks(){
        console.log("banks called")
        return API.get(`api/companyBankAcc/banks`);
    },
    getCurrencies(){
        console.log("currencies called")
        return API.get(`api/companyBankAcc/currencies`);
    },
    archiveBankAccount(uuid) {
        return API.put(`api/companyBankAcc/archive/${uuid}`);
    },
    unarchiveBankAccount(uuid) {
        
        return API.put(`api/companyBankAcc/unarchive/${uuid}`);
    },
    getGlAccounts(){
        return API.get(`api/companyBankAcc/glAccounts`);

    },
    getTransactions(uuid){
        return API.get(`api/companyBankAcc/transactions/${uuid}`);

    },
    createBank(data){
        return API.post(`api/companyBankAcc/createBank`,data);
    }


   
}